<template lang="pug">
  app-toolbar-item(label="Период" :items="$_short_period_items" key-name="title") 
    slot

    template(slot="append")
      app-dialog-date-picker(v-model="dialogDay" ref="dialogDay" type="day" @confirm="$_filterByPeriod")
      app-dialog-date-picker-period(v-model="dialogPeriod" ref="dialogPeriod" @confirm="$_filterByPeriod")
</template>

<script>
import { $_app_moment } from "@/common/AppMoment.js"

export default {
  inheritAttrs: true,
  name: 'app-toolbar-item-period-short',
  mixins: [ $_app_moment ],

  methods: {
    $_chooseDay () {
      this.$refs.dialogDay.show()
    },

    $_choosePeriod () {
      this.$refs.dialogPeriod.show()
    },

    $_filterByPeriod (period) {
      this.$emit('select', period)
    }
  },

  data () {
    return {
      dialogDay: false,
      dialogPeriod: false,
    }
  }
}
</script>